import React from 'react';
import { FormCheckbox } from '../../FormFields';
import { TimeControlWithOptions } from '../../TimeControls/TimeControlWithOptions';
import { LabeledValue } from '../../LabeledValue';
import { getOffsetLabel } from '../../../utils/time';

const CustomSpecificTime = ({
  specificTime,
  setSpecificTime,
  showSpecificTime,
  onChangeShowSpecificTime,
  minTime,
  maxTime,
  excludeRange,
}) => {
  const handleInputChange = (name, val) => {
    const newSpecificTime = {
      ...specificTime,
      [name]: val,
    };

    setSpecificTime(newSpecificTime);
  };

  const getDurationValueLabel = () => {
    const [startHour, startMinute] = specificTime.start.split(':');
    const [endHour, endMinute] = specificTime.end.split(':');
    const diff1 = Number(startHour) * 60 + Number(startMinute);
    const diff2 = Number(endHour) * 60 + Number(endMinute);

    return getOffsetLabel(diff2 - diff1);
  };

  return (
    <div className="datepicker-custom-range__specific-time">
      <FormCheckbox
        label="SpecificTime"
        checked={showSpecificTime}
        onChange={() => onChangeShowSpecificTime(!showSpecificTime)}
        rounded
      />

      {showSpecificTime ? (
        <div className="datepicker-custom-range__specific-time-controls-container">
          <div className="datepicker-custom-range__specific-time-controls">
            <TimeControlWithOptions
              className="time-control-with-options__datepicker"
              interval={15}
              time={specificTime.start}
              minTime={minTime}
              maxTime={maxTime}
              excludeRange={excludeRange}
              onChange={(e) => handleInputChange('start', e)}
            />

            <span>to</span>

            <TimeControlWithOptions
              className="time-control-with-options__datepicker"
              interval={15}
              time={specificTime.end}
              onChange={(e) => handleInputChange('end', e)}
              minTime={specificTime.start}
              maxTime={maxTime}
              excludeRange={excludeRange}
              startTime={specificTime.start}
            />
          </div>

          <div className="datepicker-custom-range__specific-time-duration">
            <LabeledValue label="Duration" value={getDurationValueLabel()} />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default CustomSpecificTime;
